import React from "react";
import { Icon } from "./icons";

// The V2 pager: a round previous button, "Page X of Y", a round next
// button. The arrows disable at the ends and carry accessible names, and
// `onChange` receives the page to show.
//
//   <Pagination page={page} pageCount={10} onChange={setPage} />

const ARROW =
  "flex h-8 w-8 items-center justify-center rounded-full border border-bm-border bg-white text-bm-muted transition-colors hover:bg-bm-subtle hover:text-bm-ink disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-white disabled:hover:text-bm-muted";

const Pagination = ({ page, pageCount, onChange, label = "Pagination", className = "" }) => {
  if (!pageCount || pageCount < 1) return null;
  const atStart = page <= 1;
  const atEnd = page >= pageCount;
  return (
    <nav aria-label={label} className={`flex items-center justify-center gap-3 ${className}`.trim()}>
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={atStart}
        aria-label="Previous page"
        className={ARROW}
      >
        <Icon name="chevron-left" size={14} />
      </button>
      <span className="inline-flex h-8 items-center rounded-full bg-bm-mutedbg px-4 bm-label-m text-bm-ink">
        Page {page} of {pageCount}
      </span>
      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={atEnd}
        aria-label="Next page"
        className={ARROW}
      >
        <Icon name="chevron-right" size={14} />
      </button>
    </nav>
  );
};

export default Pagination;
